<template>
  <div class="main__div">
    <el-container class="el-container__main">
      <new-main-left-menu v-if="hasNewLeftNavPermission" />
      <main-left-menu v-else />

      <el-main>
        <transition name="fade">
          <slot> <h1>Router View should be here! </h1></slot>
        </transition>
      </el-main>
    </el-container>
    <main-footer
        :hidden="hasNewLeftNavPermission" />
  </div>
</template>

<script>
import MainFooter from "@/containers/Core/Footer";
import MainLeftMenu from "@/containers/Core/MainLeftMenu";
import NewMainLeftMenu from "../../NewUI/containers/core/leftNavBar/NewMainLeftMenu";
import { createNamespacedHelpers } from "vuex";
import permission from "@/mixins/permission";

const { mapGetters: uiGetters } = createNamespacedHelpers("ui");

const { mapActions: sharedActions, mapMutations: sharedMutations } =
  createNamespacedHelpers("shared");

export default {
  name: "Main",
  components: { MainFooter, MainLeftMenu, NewMainLeftMenu },
  mixins: [permission],
  computed: {
    ...uiGetters(["isLoading"]),
    hasNewLeftNavPermission() {
      return this.hasPermission("NewUI", "leftNav");
    },
  },
  created() {
    this.fetchPIIAuthorizationStatus()
      .then((response) => {
        this.setPiiAuthorizationStatus(response.data.authorization.status);
      })
      .catch((error) => {
        console.error("Could not fetch Pii Authorization Status", error);
        this.setPiiAuthorizationStatus("revoked");
      });
  },
  methods: {
    ...sharedMutations(["setPiiAuthorizationStatus"]),
    ...sharedActions(["fetchPIIAuthorizationStatus"]),
  },
};
</script>

<style lang="scss">
.main__div {
  height: 100%;
}

.el-container__main {
  height: 100%;
}

.el-main {
  padding: 20px 0;
}
</style>
